<ng-container>
  <div mat-dialog-title>
    <span>{{ title$ | async | translate }}</span>
    <q9-dialog-close-button></q9-dialog-close-button>
  </div>

  <div class="create-new-view-dialog">
    <mat-horizontal-stepper
      class="cv-stepper"
      #stepper
      [linear]="true"
      (selectionChange)="onStepChange($event)">
      <ng-template matStepperIcon="edit">
        <mat-icon svgIcon="edit"></mat-icon>
      </ng-template>

      <mat-step [completed]="scopeCompleted">
        <ng-template matStepLabel>{{ 'RUBIC_CUBE.STEP_SCOPE' | translate }}</ng-template>
      </mat-step>
      <mat-step [completed]="columnsCompleted">
        <ng-template matStepLabel>{{ 'RUBIC_CUBE.STEP_COLUMNS' | translate }}</ng-template>
      </mat-step>
      <mat-step [completed]="filtersCompleted">
        <ng-template matStepLabel>{{ 'RUBIC_CUBE.STEP_FILTERS' | translate }}</ng-template>
      </mat-step>
    </mat-horizontal-stepper>

    <q9-content-loader [isLoading]="loading$ | async"></q9-content-loader>

    <ng-container *ngIf="!(loading$ | async)">
      <ng-container [ngSwitch]="view$ | async">
        <ng-container *ngSwitchCase="viewState.SELECT_METADATA">
          <app-select-metadata-view
            [disableGlobalViewCreation]="disableGlobalViewCreation"
            [disablePrivateViewCreation]="disablePrivateViewCreation"
            [isViewer]="isViewer"
            (scopeStateChange)="onScopeStateChange($event)"
            (confirmSelected)="goToColumnsStep()"></app-select-metadata-view>
        </ng-container>

        <ng-container *ngSwitchCase="viewState.SELECT_COLUMNS">
          <app-select-columns-view
            (columnsStateChange)="onColumnsStateChange($event)"
            (confirmColumnsSelect)="storeSelectedColumns($event)"
            (cancelColumnsSelect)="resetColumns()"></app-select-columns-view>
        </ng-container>

        <ng-container *ngSwitchCase="viewState.ADD_FILTERS">
          <app-add-filters-view
            (submitForm)="submit($event)"
            (cancelFiltersSelect)="resetFilters()"></app-add-filters-view>
        </ng-container>
      </ng-container>
    </ng-container>
  </div>
</ng-container>
